import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./PaymentModal.module.css";

interface PaymentModalProps {
  show: boolean;
  handleClose: () => void;
  handleSubmit: (values: any, userEmail: string | null) => void;
  values: any;
  price: number;
  /** Tytuł w headerze modala */
  title?: string;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  show,
  handleClose,
  handleSubmit,
  values,
  price,
  title = "Dodaj nową wizytówkę do serwisu CARTENA",
}) => {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!show) return;

    try {
      const userDataRaw = localStorage.getItem("user");

      if (!userDataRaw) {
        setUserEmail(null);
        return;
      }

      const user = JSON.parse(userDataRaw);

      if (user?.role === "Admin" && values?.user) {
        setUserEmail(values.user);
        return;
      }

      setUserEmail(user?.email ?? null);
    } catch (err) {
      console.error("Błąd przy pobieraniu user.email:", err);
      setUserEmail(null);
    }
  }, [show, values?.user]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      fullscreen
      className={styles.fullScreenModal}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.modalBody}>
        <div className={styles.modalContainer}>
          {/* === Rachunek === */}
          <section>
            <h5 className={styles.sectionTitle}>
              🧾 Rachunek
            </h5>

            <p>
              Po zatwierdzeniu zostanie wygenerowany rachunek
              zawierający dane potrzebne do wykonania przelewu.
            </p>

            <div className={styles.amountBlock}>
              <strong>Kwota:</strong>{" "}
              <span>
                {price.toFixed(2)} PLN netto /{" "}
                {(price * 1.23).toFixed(2)} PLN brutto
              </span>
            </div>
          </section>

          <hr className={styles.divider} />

          {/* === Dane do faktury === */}
          <section>
            <h5 className={styles.sectionTitle}>
              🧾 Dane do faktury
            </h5>

            <div className={styles.invoiceBox}>
              <strong>{values.name}</strong>
              <br />

              {values.street} {values.streetNumber}
              {values.localNumber
                ? "/" + values.localNumber
                : null}

              <br />

              {values.zipCode} {values.city}

              <br />

              NIP: {values.NIP}
            </div>

            <p className={styles.invoiceEmail}>
              📧 Faktura zostanie wysłana na adres:{" "}
              <strong>
                {userEmail ??
                  "adres e-mail nie został jeszcze ustawiony"}
              </strong>
            </p>
          </section>
        </div>
      </Modal.Body>

      <Modal.Footer className={styles.modalFooter}>
        <div className={styles.footerButtons}>
          <Button
            variant="success"
            onClick={() =>
              handleSubmit(values, userEmail)
            }
            className={styles.payBtn}
          >
            🧾 Generuj rachunek
          </Button>

          <Button
            variant="outline-secondary"
            onClick={handleClose}
            className={styles.cancelBtn}
          >
            Anuluj
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;